export class TransactionEnumsModel {
  constructor() {}
  public listDirectionFlag: Array<any>;
  public listCurrency: [];
  public listRegularFlag: [];
}
